<template>
    <div class="date-range-picker">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Fecha Inicio
          </label>
          <input
            type="date"
            v-model="localFromDate"
            @change="updateDates"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            :max="localToDate"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Fecha Fin
          </label>
          <input
            type="date"
            v-model="localToDate"
            @change="updateDates"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            :min="localFromDate"
          />
        </div>
      </div>
      
      <!--Botones de rangos predefinidos-->
      <div class="flex flex-wrap gap-2 mb-4">
        <button
          v-for="preset in presets"
          :key="preset.label"
          @click="applyPreset(preset)"
          class="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        >
          {{ preset.label }}
        </button>
      </div>
      
      <!--Botón para aplicar filtros-->
      <div class="flex justify-end">
        <button
          @click="applyFilter"
          :disabled="!localFromDate || !localToDate"
          class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
        >
          Aplicar Filtro
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DateRangePicker',
    props: {
      fromDate: {
        type: String,
        default: ''
      },
      toDate: {
        type: String,
        default: ''
      },
      showPresets: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        localFromDate: this.fromDate,
        localToDate: this.toDate,
        presets: [
          {
            label: 'Últimos 7 días',
            days: 7
          },
          {
            label: 'Últimos 30 días',
            days: 30
          },
          {
            label: 'Últimos 90 días',
            days: 90
          },
          {
            label: 'Este año',
            custom: () => {
              const now = new Date();
              const startOfYear = new Date(now.getFullYear(), 0, 1);
              return {
                from: this.formatDate(startOfYear),
                to: this.formatDate(now)
              };
            }
          }
        ]
      };
    },
    watch: {
      fromDate(newVal) {
        this.localFromDate = newVal;
      },
      toDate(newVal) {
        this.localToDate = newVal;
      }
    },
    methods: {
      formatDate(date) {
        return date.toISOString().split('T')[0];
      },
      
      updateDates() {
        this.$emit('update:fromDate', this.localFromDate);
        this.$emit('update:toDate', this.localToDate);
      },
      
      applyPreset(preset) {
        if (preset.custom) {
          const dates = preset.custom();
          this.localFromDate = dates.from;
          this.localToDate = dates.to;
        } else {
          const today = new Date();
          const fromDate = new Date(today);
          fromDate.setDate(today.getDate() - preset.days);
          
          this.localFromDate = this.formatDate(fromDate);
          this.localToDate = this.formatDate(today);
        }
        
        this.updateDates();
        this.applyFilter();
      },
      
      applyFilter() {
        this.$emit('filter', {
          from: this.localFromDate,
          to: this.localToDate
        });
      }
    },
    mounted() {
      // Si no hay fechas iniciales, establecer valores por defecto
      if (!this.localFromDate || !this.localToDate) {
        const today = new Date();
        const thirtyDaysAgo = new Date(today);
        thirtyDaysAgo.setDate(today.getDate() - 30);
        
        this.localFromDate = this.formatDate(thirtyDaysAgo);
        this.localToDate = this.formatDate(today);
        
        this.updateDates();
      }
    }
  };
  </script>